import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../../resources/logo.svg";

const useStyles = makeStyles((theme) => ({
  logoHeader: {
    padding: theme.spacing(3, 0, 1, 4),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(3, 0, 1, 0),
    },
  },
}));

const LogoHeader = () => {
  const classes = useStyles();

  return (
    <div className={classes.logoHeader}>
      <img alt={"Logo"} src={logo} style={{ maxHeight: 50, width: 160 }} />
    </div>
  );
};

export default LogoHeader;
